import { render, staticRenderFns } from "./IncidentViewResolver.vue?vue&type=template&id=486cfbff&scoped=true&"
import script from "./IncidentViewResolver.vue?vue&type=script&lang=js&"
export * from "./IncidentViewResolver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486cfbff",
  null
  
)

export default component.exports